import { Box } from '@wishket/design-system';

import { Skeleton } from '@/shared/Components';

const MostScrappedContentsSkeleton = () => {
  return (
    <Box className="grid grid-cols-1 gap-5 tablet:grid-cols-2 desktop:gap-x-6 desktop:gap-y-8">
      {Array.from({ length: 6 }).map((_, index) => (
        <Skeleton className="h-[112px] flex-1 tablet:h-[168px]" key={index} />
      ))}
    </Box>
  );
};

export default MostScrappedContentsSkeleton;
